import { useEffect, useState } from "react";
import { GraduationCap, CheckCircle, Play } from "@phosphor-icons/react";
import { teleproApi } from "../../lib/teleproApi";
import TrainingModal from "./TrainingModal";

// VAGUE 46 — Formation interactive : leçons + jeu de rôle IA.
export default function TrainingCard() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const load = () => teleproApi.get("/training").then((r) => setData(r.data)).catch(() => setData({ error: true }));
  useEffect(() => { load(); }, []);

  return (
    <section className="bg-card border border-border rounded-sm p-4 sm:p-5 mb-6" data-testid="training-card">
      <div className="flex items-center justify-between gap-2 mb-1">
        <h3 className="font-display text-base font-medium flex items-center gap-2">
          <GraduationCap size={17} weight="duotone" className="text-primary"/> Formation : s&apos;entraîner avec un faux prospect
        </h3>
        {data?.total && (
          <span className="text-xs font-semibold text-muted-foreground" data-testid="training-progress">
            {data.completed}/{data.total} modules validés
          </span>
        )}
      </div>
      <p className="text-xs text-muted-foreground mb-3">
        Lis la leçon, puis joue l&apos;appel : l&apos;IA joue le commerçant et te note à la fin. Accessible à tout moment, sans impact sur tes listes.
      </p>
      {data?.total && (
        <div className="h-1.5 bg-muted rounded-full overflow-hidden mb-3">
          <div className="h-full bg-primary transition-[width] duration-500" style={{ width: `${(100 * data.completed) / data.total}%` }}/>
        </div>
      )}
      {!data ? <div className="text-sm text-muted-foreground">Chargement…</div>
        : data.error ? <div className="text-sm text-secondary">Formation indisponible pour le moment.</div> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {data.modules.map((m, i) => (
            <button key={m.id} type="button" onClick={() => setOpen(m)}
              className="text-left border border-border rounded-sm p-3 hover:border-primary hover:bg-primary/5 transition-colors group"
              data-testid={`training-module-${m.id}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Module {i + 1}</span>
                {m.completed
                  ? <CheckCircle size={16} weight="fill" className="text-emerald-600" data-testid={`training-module-done-${m.id}`}/>
                  : <Play size={14} className="text-muted-foreground group-hover:text-primary"/>}
              </div>
              <div className="text-sm font-semibold mt-0.5">{m.title}</div>
              <div className="text-[11px] text-muted-foreground mt-1">
                {m.attempts ? `Meilleure note ${m.best_score}/10 · ${m.attempts} essai${m.attempts > 1 ? "s" : ""}` : "Pas encore commencé"}
              </div>
            </button>
          ))}
        </div>
      )}
      {open && <TrainingModal module={open} passScore={data.pass_score} onClose={() => { setOpen(null); load(); }}/>}
    </section>
  );
}
